import { SelectShippingAddressErrorText } from "constants/text";
import { models } from "types/api/viewModels";
import { InferType, mixed, object, string } from "yup";

export interface TruckStopSchemaProps {
	address: models["AddressViewModel"];
	shipToId?: string | null;
}

export const truckStopSchema = object({
	address: mixed<models["AddressViewModel"]>().required(SelectShippingAddressErrorText),
	shipToId: string().nullable(),
	truckStopId: string().optional()
});

export interface AddTruckStopSchemaProps {
	stop: TruckStopSchemaProps;
}

export const addTruckStopSchema = object({
	stop: truckStopSchema
});

export type AddTruckStopFields = InferType<typeof addTruckStopSchema>;
